import { Component, OnInit } from '@angular/core';
import { SitesService } from '../../../core/services/data/sites.service';
import { PurchaseProcessService } from '../../../core/services/data/purchase-process.service';
import { UserService } from '../../../core/services/data/user.service';
import { ExperimentsService } from '../../../core/services/experiments.service';

@Component({
	selector: 'app-features-step1',
	templateUrl: './features-step1.component.html',
	styleUrls: ['./features-step1.component.scss'],
})
export class FeaturesStep1Component implements OnInit {
	public sites$;

	public loading = true;

	public user;

	public variant = 'control';

	public sites = [];

	get displayPromoStacksModalForFeatures() {
		return this.variant === 'experimental';
	}

	constructor(
		private ss: SitesService,
		private purchaseProcessService: PurchaseProcessService,
		private uss: UserService,
		private es: ExperimentsService,
	) {}

	ngOnInit() {
		this.purchaseProcessService.reset();
		this.ss.sitesStore$.subscribe((sites) => {
			this.sites = sites.filter((site) => !site.hiddenFromFeatures);
		});
		this.loading = false;

		this.resetScroll();
		this.uss.fetchUser().then((data: any) => {
			this.user = data;
		});

		this.checkExperimental();
	}

	resetScroll() {
		window.scrollTo(0, 0);
	}

	checkExperimental() {
		this.variant = this.es.getVariant();
	}
}
